import useWeb3 from '@/services/web3/useWeb3';
import { uidStore } from '@/store/uid';
import { UniqueIdentity } from '@/services/balancer/contracts/contracts/unique-identity';
import { networkConfig } from './useNetwork';

export default function useUIDCheck() {
  const { account, getSigner } = useWeb3();

  const checkIsVerified = async () => {
    const uniqueIdentity = new UniqueIdentity(
      networkConfig.addresses.untangled?.uniqueIdentity || ''
    );
    const signer = getSigner();
    const userAddress = await signer.getAddress();
    uidStore.checkIsVerified(uniqueIdentity, userAddress).finally();
  };

  watch(
    account,
    () => {
      checkIsVerified();
    },
    { immediate: true }
  );
}
